const C = {
  name: "Monitoring",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
    <path d="M38 0H2C0.9 0 0 0.9 0 2V12C0 12.55 0.45 13 1 13C1.55 13 2 12.55 2 12V2H37C37.55 2 38 2.45 38 3V27H3C2.45 27 2 26.55 2 26V19H7C7.35 19 7.68 18.82 7.86 18.51L9.97 15L14.13 22.49C14.31 22.82 14.67 23.03 15.04 23C15.42 22.99 15.75 22.76 15.91 22.42L21.99 9.39L26.09 18.41C26.25 18.77 26.61 19 27 19H33C33.55 19 34 18.55 34 18C34 17.45 33.55 17 33 17H27.64L22.91 6.59C22.75 6.23 22.4 6 22 6C21.61 6 21.26 6.23 21.09 6.58L14.92 19.8L10.87 12.51C10.7 12.2 10.37 12 10.01 12C9.68 12.01 9.32 12.18 9.14 12.49L6.43 17H2C0.9 17 0 17.9 0 19V27V33V34C0 34.55 0.45 35 1 35H2H14.78L14.18 38H13C12.45 38 12 38.45 12 39C12 39.55 12.45 40 13 40H27C27.55 40 28 39.55 28 39C28 38.45 27.55 38 27 38H25.82L25.22 35H38H39C39.55 35 40 34.55 40 34V33V27V2C40 0.9 39.1 0 38 0ZM23.78 38H16.22L16.82 35H23.18L23.78 38ZM2 32V29H37C37.55 29 38 29.45 38 30V33H3C2.45 33 2 32.55 2 32Z" />
    </g>
  `
};
export {
  C as Monitoring
};
